var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#50A9FC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.429 24.027c.479 0 .872-.154 1.18-.462.308-.308.462-.702.462-1.181v-4.929c0-.479-.154-.872-.462-1.18-.308-.308-.701-.462-1.18-.462-.48 0-.873.154-1.181.462-.308.308-.462.701-.462 1.18v4.929c0 .48.154.873.462 1.18.308.309.701.463 1.18.463zm-2.465-3.286v-1.643H16v1.643h13.964zm9.036 0v-1.643h-4.107v1.643H39zM22.571 31.42c.48 0 .873-.154 1.181-.462.308-.308.462-.702.462-1.181v-4.929c0-.479-.154-.873-.462-1.18-.308-.309-.701-.463-1.18-.463-.48 0-.873.154-1.181.462-.308.308-.462.702-.462 1.181v4.929c0 .479.154.873.462 1.18.308.309.701.463 1.18.463zm-2.464-3.286V26.49H16v1.643h4.107zm18.893 0V26.49H25.036v1.643H39zm-6.571 10.678c.479 0 .872-.154 1.18-.462.308-.308.462-.701.462-1.18V32.24c0-.48-.154-.873-.462-1.18-.308-.309-.701-.463-1.18-.463-.48 0-.873.154-1.181.462-.308.308-.462.702-.462 1.181v4.929c0 .479.154.872.462 1.18.308.308.701.462 1.18.462zm-2.465-3.285v-1.643H16v1.643h13.964zm9.036 0v-1.643h-4.107v1.643H39z",
    transform: "translate(-681 -187) translate(15 172) translate(650)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic-filter.a2ebf4abfee9f65216b496f4eec94c3a.svg";
export { ForwardRef as ReactComponent };